import * as userActionTypes from '@/StoreWeb/store/modules/user/action-types'
import store from '@/StoreWeb/store/store'
import { isEmpty } from 'global-utils'
import i18n from 'i18n'
import cloneDeep from 'lodash.clonedeep'

export const getWalletProvidersWithCartFareMedias = () => {
    const providers = cloneDeep(store.getters.getWalletProviders)
    const cartFareMedias = store.getters.getCartFareMedias

    if (!isEmpty(cartFareMedias)) {
        cartFareMedias.forEach(cartFareMedia => {
            const provider = providers.find(provider => provider.id === cartFareMedia.providerId)

            if (!isEmpty(provider) && !isEmpty(provider.accounts)) {
                const providerAccount = provider.accounts.find(account => account.providerUserExternalId === cartFareMedia.providerUserExternalId)

                if (providerAccount) {
                    const cartFareMediasAddedForCurrentAccount = cartFareMedias.filter(fareMedia => fareMedia.providerUserExternalId === providerAccount.providerUserExternalId)

                    if (providerAccount && cartFareMediasAddedForCurrentAccount.length > 0) {
                        if (providerAccount.fareMedias) {
                            providerAccount.fareMedias = [...cartFareMediasAddedForCurrentAccount, ...providerAccount.fareMedias]
                        } else {
                            providerAccount.fareMedias = [...cartFareMediasAddedForCurrentAccount]
                        }
                    }
                }
            }
        })
    }

    return providers
}

export const createHceMedia = async (provider = 'conduent') => {
    const providerAccount = store.getters.getWalletProviderAccounts.find(account => {
        return account.provider === provider
    })

    if (providerAccount) {
        try {
            const response = await store.dispatch(userActionTypes.CREATE_HCE_MEDIA, {
                providerId: providerAccount.provider,
                providerUserExternalId: providerAccount.providerUserExternalId
            })

            if (response?.baskets[0]?.providerFareMediaId) {
                return {
                    temporaryFareMediaId: response.baskets[0].providerFareMediaId
                }
            }
        } catch (error) {
            return {
                error: error?.response?.data
            }
        }
    }

    return {
        error: {
            message: i18n.global.t('hce:create_media:error:no_provider_account')
        }
    }
}
